import { Expose } from "class-transformer";
import { IsBoolean } from "class-validator";

export class CanIssueReceipt {
  @Expose()
  @IsBoolean()
  showReceiptWindow!: boolean;
  @Expose()
  @IsBoolean()
  showCashDocumentWindow!: boolean;
  @Expose()
  @IsBoolean()
  showCanSettleAllWindow!: boolean;
  // @Expose()
  // @IsBoolean()
  // addPaymentAfterGenerate!: boolean;
}
